import _parseFloat from "@babel/runtime-corejs3/core-js-stable/parse-float";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useMemo, useState } from 'react';
import './style.scss';
import { RadioButtons } from '@eika/radio-button';
import { formatPrice } from '@eika-forsikring/formats';
import { lowIncomeMaxRate, maxCoveredGs, monthsInYear, uforetrygd } from './constants';
var RadioOptionType = /*#__PURE__*/function (RadioOptionType) {
  RadioOptionType["PerManed"] = "per m\xE5ned";
  RadioOptionType["PerAr"] = "per \xE5r";
  return RadioOptionType;
}(RadioOptionType || {});
const UforekalkulatorCalculations = _ref => {
  let {
    yearlyIncome,
    grunnbelop
  } = _ref;
  const [selectedOption, setSelectedOption] = useState(RadioOptionType.PerManed.toString());
  const incomeUpTo6G = useMemo(() => {
    if (grunnbelop) {
      return yearlyIncome > maxCoveredGs * grunnbelop ? maxCoveredGs * grunnbelop : yearlyIncome;
    }
    return 0;
  }, [grunnbelop, yearlyIncome]);
  const montlyIncome = Math.round(_parseFloat(String(yearlyIncome / monthsInYear)));
  const montlyIncomeNav = Math.round(_parseFloat(String(incomeUpTo6G / monthsInYear * uforetrygd)));
  const montlyLoss = montlyIncome - montlyIncomeNav;
  const yearlyIncomeNav = Math.round(_parseFloat(String(incomeUpTo6G * uforetrygd)));
  const yearlyLoss = yearlyIncome - yearlyIncomeNav;
  const lowIncome = yearlyIncome <= lowIncomeMaxRate;
  const values = {
    [RadioOptionType.PerManed]: {
      todaysIncome: 'Dagens månedsinntekt',
      todaysIncomeSum: formatPrice(montlyIncome),
      incomeNav: 'Månedsinntekt ved uførhet (uføretrygd fra NAV)',
      incomeNavSum: formatPrice(montlyIncomeNav),
      totalLoss: 'Månedlig inntektstap',
      totalLossSum: formatPrice(montlyLoss)
    },
    [RadioOptionType.PerAr]: {
      todaysIncome: 'Dagens årsinntekt',
      todaysIncomeSum: formatPrice(yearlyIncome),
      incomeNav: 'Årssinntekt ved uførhet (uføretrygd fra NAV)',
      incomeNavSum: formatPrice(yearlyIncomeNav),
      totalLoss: 'Årlig inntektstap',
      totalLossSum: formatPrice(yearlyLoss)
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "uforekalkulator__calculations"
  }, !lowIncome && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RadioButtons, {
    className: "radio-buttons",
    label: "Inntektstap f\xF8r skatt",
    name: "radio-buttons-med-label-horisontal",
    onChange: setSelectedOption,
    selectedOption: selectedOption,
    options: [{
      value: RadioOptionType.PerManed.toString(),
      key: 'mnd'
    }, {
      value: RadioOptionType.PerAr.toString(),
      key: 'ar'
    }],
    horizontal: true
  }), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "todaysIncome"
  }, values[selectedOption].todaysIncome), /*#__PURE__*/React.createElement("div", {
    className: "bold"
  }, values[selectedOption].todaysIncomeSum)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "incomeNav"
  }, values[selectedOption].incomeNav), /*#__PURE__*/React.createElement("div", {
    className: "bold"
  }, values[selectedOption].incomeNavSum))), /*#__PURE__*/React.createElement("div", {
    className: "horizontal-line-wrapper"
  }, /*#__PURE__*/React.createElement("hr", null)), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "typography-subtitle"
  }, values[selectedOption].totalLoss), /*#__PURE__*/React.createElement("div", {
    className: "typography-h2 bold"
  }, values[selectedOption].totalLossSum)))), /*#__PURE__*/React.createElement("div", null, lowIncome && /*#__PURE__*/React.createElement("p", {
    className: "typography-subtitle"
  }, "Med din \xE5rsinntekt vil du v\xE6re tilstrekkelig dekket gjennom NAV hvis du skulle bli uf\xF8r")));
};
export default UforekalkulatorCalculations;